export type IfoStatus = 'coming_soon' | 'live' | 'finished'

export interface Ifo {
  id: string
  isActive: boolean
  address: string
  name: string
  subTitle?: string
  description?: string
  launchDate: string
  launchTime: string
  saleAmount: string
  raiseAmount: string
  cakeToBurn: string
  projectSiteUrl: string
  currency: string
  currencyAddress: string
  tokenDecimals: number
  releaseBlockNumber: number
}

export enum QuoteToken {
  'BNB' = 'MATIC',
  'WBNB' = 'WMATIC',
  'CAKE' = 'DELIRIUM',
  'SYRUP' = 'SYRUP',
  'USDC' = 'USDC',
  'TWT' = 'TWT',
  'UST' = 'UST',
  'WMATIC' = 'WMATIC',
  'MATIC' = 'MATIC',
  'WETH' = 'WETH',
  'ETH' = 'ETH',
  'USDT' = 'USDT',
  'BUSD' = 'BUSD',
  'QUICK' = 'QUICK'
}

export enum PoolCategory {
  'COMMUNITY' = 'Community',
  'CORE' = 'Core',
  'PARTNERSHIP' = 'Partnership',
}

export interface Address {
  80001?: string
  137: string
}

export interface FarmConfig {
  pid: number
  lpSymbol: string
  lpAddresses: Address
  tokenSymbol: string
  tokenAddresses: Address
  quoteTokenSymbol: QuoteToken
  quoteTokenAdresses: Address
  multiplier?: string
  isTokenOnly?: boolean
  isCommunity?: boolean
  otherExchange?: string
  risk: number
  decimal: number
  dual?: {
    rewardPerBlock: number
    earnLabel: string
    endBlock: number
  }
}

export interface VaultConfig {
  pid: number
  farmPid: number
  lpSymbol: string
  lpAddresses: Address
  tokenSymbol: string
  tokenAddresses: Address
  quoteTokenSymbol: QuoteToken
  quoteTokenAdresses: Address
  // multiplier?: string
  isTokenOnly?: boolean
  // isCommunity?: boolean
  // otherExchange?: string
  decimal: number
  earnSymbol: string
  earnDecimal: number
  from: string
  abiFile: string
  strategyAddresses: Address
  compoundFrequency: number,
  performanceFee: number,
// dual?: {
  //   rewardPerBlock: number
  //   earnLabel: string
  //   endBlock: number
  // }
}

export interface PoolConfig {
  sousId: number
  image?: string
  tokenName: string
  stakingTokenName: string
  stakingLimit?: number
  stakingTokenAddress?: string
  contractAddress: Address
  lpAddress: Address
  quoteTokenAdress: Address
  tokenAddress: Address
  poolCategory: PoolCategory
  projectLink: string
  tokenPerBlock: string
  sortOrder?: number
  harvest?: boolean
  isFinished?: boolean
  tokenDecimals: number
  stakingTokenDecimals: number
  poolBalance: number
  harvestLockup: number
  withdrawLockup: number
  partnerColor: string
  experienceBalance?: number
}

export type Nft = {
  name: string
  description: string
  originalImage: string
  previewImage: string
  blurImage: string
  sortOrder: number
  bunnyId: number
}
